import { render, staticRenderFns } from "./PromotionalOffers.vue?vue&type=template&id=752bb25e&scoped=true&"
import script from "./PromotionalOffers.vue?vue&type=script&lang=js&"
export * from "./PromotionalOffers.vue?vue&type=script&lang=js&"
import style0 from "./PromotionalOffers.vue?vue&type=style&index=0&id=752bb25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752bb25e",
  null
  
)

export default component.exports